import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { DISCLAIMER_CONSULTATION_RESULTS_INGREDIENTS_CANCEL } from 'consts/copy';

import { SIMPLE_HERO_LAYOUT, type SimpleHeroProps } from '../SimpleHero';

export const SIMPLE_HERO_CLINDAMYCIN_CONTENT: SimpleHeroProps = {
  header: (
    <React.Fragment>
      Clindamycin for <br />
      clearer skin
    </React.Fragment>
  ),
  body: 'Get to the root cause of breakouts. This topical antibiotic tackles acne-contributing bacteria to help banish blemishes and keep your skin clear.',
  ctaButton: {
    buttonText: 'Get your custom formula',
    disclaimerText: DISCLAIMER_CONSULTATION_RESULTS_INGREDIENTS_CANCEL,
  },
  media: (
    <StaticImage
      src="../images/headerClindamycinDesktop@2x.jpg"
      alt="woman putting on custom formula"
      loading="eager"
    />
  ),
  layout: SIMPLE_HERO_LAYOUT.imageLast,
};
